'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import useTitanAnalytics from '@/hooks/useTitanAnalytics';

interface TitanPageViewProps {
  profileId?: string;
}

export default function TitanPageView({ profileId }: TitanPageViewProps) {
  const titan = useTitanAnalytics();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') return;

    titan
      .page({
        channel: 'web',
        type: 'page',
        context: {},
        userId: profileId ?? null,
        properties: {
          url: window.location.href,
          narvar_product_context: 'track',
        },
      })
      // eslint-disable-next-line no-console
      .catch((e: unknown) => console.error(e));
  }, [titan, pathname, searchParams, profileId]);

  return <></>;
}
